import React from 'react';
import { Backdrop, CircularProgress } from '@mui/material';
import { useLoading } from 'contextProviders/LoadingBackdropProvider';

/**
 * Implements a global loading backdrop that can be used to show a loading spinner when a request is being made. Uses the useLoading hook from the LoadingBackdropProvider context provider.
 * @returns A global loading backdrop that can be used to show a loading spinner when a request is being made.
 */
const LoadingBackdropGlobal: React.FC = () => {
	const { isLoading } = useLoading();

	return (
		<Backdrop
			sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
			open={isLoading}
		>
			<CircularProgress color="inherit" />
		</Backdrop>
	);
};

export default LoadingBackdropGlobal;
